import { useState } from "react";
import { Modal } from "antd";

interface CaptionedImageProps {
  src: string;
  alt: string;
  description?: string;
  maxHeight: string;
  className?: string;
  style?: React.CSSProperties;
}

export function CaptionedImage({
  src,
  alt,
  description,
  maxHeight,
  className = "",
  style = {},
}: CaptionedImageProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={className} style={style}>
        <div className="bg-gray-1 pa-4 br-2 pointer" onClick={showModal}>
          <div className="flex justify-center mb-3">
            <img
              src={src}
              alt={alt}
              className="br-2 w-100"
              style={{ maxHeight, objectFit: "contain" }}
            />
          </div>
          <p className="f-3 gray-9 tc mb-0">{description}</p>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width="90vw"
        style={{ top: 20 }}
        styles={{
          body: { padding: "20px" },
        }}
      >
        <div className="tc">
          <img
            src={src}
            alt={alt}
            className="w-100 mb-3 br-2"
            style={{ maxHeight: "80vh", objectFit: "contain" }}
          />
          <p className="f-4 gray-8 mb-0">{description}</p>
        </div>
      </Modal>
    </>
  );
}
